import { apiV1 } from '@listen360/js_api_client'

import {
  GET_NAVIGATION_ITEMS_ERROR,
  GET_NAVIGATION_ITEMS_PENDING,
  GET_NAVIGATION_ITEMS_SUCCESS,
  SET_CATEGORY,
  SET_TAB,
  TOGGLE_SIDEBAR
} from '@/store/constants'

export const namespaced = true

export const state = {
  category: null,
  tab: null,
  isLoadingNavigationItems: false,
  loadingNavigationItemsError: null,
  navigationItems: [],
  open: true
}

export const actions = {
  getNavigationItems({ commit }) {
    commit(GET_NAVIGATION_ITEMS_PENDING)

    return apiV1.navigationItems
      .get()
      .then(data => {
        commit(GET_NAVIGATION_ITEMS_SUCCESS, data)
      })
      .catch(error => {
        commit(GET_NAVIGATION_ITEMS_ERROR, error)
      })
  },
  setCategory({ commit }, category) {
    commit(SET_CATEGORY, category)
  },
  setTab({ commit }, { id, keepOpen }) {
    commit(SET_TAB, { id, keepOpen })
  },
  toggleSidebar({ commit }, open) {
    commit(TOGGLE_SIDEBAR, open)
  }
}

export const getters = {
  category: state => state.category,
  tab: state => state.tab,
  navigationItems: state => state.navigationItems,
  errorLoadingNavigationItems: state =>
    Boolean(state.loadingNavigationItemsError),
  isLoadingNavigationItems: state => state.isLoadingNavigationItems,
  open: state => state.open
}

export const mutations = {
  [SET_CATEGORY]: (state, category) => {
    state.category = state.category !== category ? category : ''
  },
  [SET_TAB]: (state, { id, keepOpen }) => {
    state.tab = state.tab !== id || keepOpen ? id : null
  },
  [GET_NAVIGATION_ITEMS_PENDING]: state => {
    state.isLoadingNavigationItems = true
    state.loadingNavigationItemsError = null
  },
  [GET_NAVIGATION_ITEMS_ERROR]: (state, error) => {
    state.isLoadingNavigationItems = false
    state.loadingNavigationItemsError = error
  },
  [GET_NAVIGATION_ITEMS_SUCCESS]: (state, items) => {
    state.isLoadingNavigationItems = false
    state.navigationItems = items
  },
  [TOGGLE_SIDEBAR]: (state, open) => {
    state.open = open == null ? !state.open : open
  }
}
